import { render, staticRenderFns } from "./008_NSC_Groesse.vue?vue&type=template&id=60e2fb06&scoped=true&"
import script from "./008_NSC_Groesse.vue?vue&type=script&lang=js&"
export * from "./008_NSC_Groesse.vue?vue&type=script&lang=js&"
import style0 from "./008_NSC_Groesse.vue?vue&type=style&index=0&id=60e2fb06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e2fb06",
  null
  
)

export default component.exports